/**
 * Created by mqamhieh on 10/3/17.
 */
(function (app) {

    app.controller('SendCEBAssessmentModal', [
        '$scope', 'jobData', 'cardData', 'onSuccess',
        function ($scope, jobData, cardData, onSuccess) {

            $scope.sendCEBAssessmentForm = new SendCEBAssessmentForm($scope, jobData.Brand.id, jobData.id);
            $scope.sendCEBAssessmentForm.load(cardData['id'], cardData['application_id']);

            $scope.close = function () {
                $scope.$hide();
            };

            $scope.sendAssessment = function () {
                $scope.sendCEBAssessmentForm.validator.validate(function (isValid) {
                    if (isValid) {
                        $scope.saving = true;
                        $scope.sendCEBAssessmentForm.save()
                            .then(function (assessmentData) {
                                onSuccess(assessmentData);
                                $scope.close();
                                $scope.$digest();
                            },
                            function (err) {
                                console.error(err);

                                hAlert(
                                    $filter("translate")("Something Went Wrong"),
                                    $filter("translate")("Error occurred while sending CEB assessments to this candidate.")
                                );

                                $scope.close();
                                $scope.$digest();
                            });
                    }
                })
            };
        }]);
})(angular.module('harriApp'));